<template>
  <v-btn
    v-bind="$attrs"
    v-on:click="$emit('click', $event.target.value)"
    :color="btn_color"
    class="button_text--text cstm-v-btn darken-2"
    :title="this.computedBtnText"
  >
    <v-icon v-if="this.btn_icon" small>{{ this.btn_icon }}</v-icon>
    <span v-if="!this.computedIconOnly" :class="'d-sm-inline cstm-v-btn-text ' + (this.btn_icon ? '' : 'pa-0')">{{
      this.computedBtnText
    }}</span>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: true,

  props: {
    type: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    text: {
      type: String
    },
    color: {
      type: String
    },
    icon_only: {
      type: Boolean
    },
    icon_only_xs: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      btn_text: "",
      btn_icon: "",
      btn_color: ""
    }
  },

  created() {
    this.setTextByType(this.type)
  },

  computed: {
    computedBtnText() {
      this.setTextByType(this.type)
      return this.btn_text
    },
    computedIconOnly() {
      if (this.icon_only) return true
      if (this.$vuetify.breakpoint.xsOnly && this.icon_only_xs) return true
    }
  },

  methods: {
    setTextByType(type) {
      let _text,
        _icon,
        _color = ""

      switch (type) {
        case "new":
          _text = this.$t("global.new")
          _icon = "fas fa-plus"
          _color = "success"
          break
        case "select":
          _text = this.$t("global.select")
          _icon = "fas fa-check-square"
          _color = "success"
          break
        case "save":
          _text = this.$t("global.save")
          _icon = "fas fa-save"
          _color = "success"
          break
        case "send":
          _text = this.$t("global.send")
          _icon = "fas fa-paper-plane"
          _color = "success"
          break
        case "save_and_send":
          _text = this.$t("global.save_send")
          _icon = "fas fa-paper-plane"
          _color = "success"
          break
        case "save_without_notification":
          _text = this.$t("global.save_without_notification")
          _icon = "fas fa-save"
          _color = "success"
          break
        case "notify":
          _text = this.$t("global.notify")
          _icon = "fas fa-paper-plane"
          _color = "success"
          break
        case "edit":
          _text = this.$t("global.edit")
          _icon = "fas fa-edit"
          _color = "info"
          break
        case "view":
          _text = this.$t("global.view")
          _icon = "fas fa-eye"
          _color = "info"
          break
        case "preview":
          _text = this.$t("global.preview")
          _icon = "fas fa-eye"
          _color = "info"
          break
        case "copy":
          _text = this.$t("global.copy")
          _icon = "fas fa-copy"
          _color = "info"
          break
        case "move":
          _text = this.$t("global.move")
          _icon = "fas fa-file-import"
          _color = "info"
          break
        case "back":
          _text = this.$t("global.back")
          _icon = "fas fa-arrow-left"
          _color = "info"
          break
        case "role":
          _text = this.$t("roles.title")
          _icon = "fas fa-edit"
          _color = "info"
          break
        case "permission":
          _text = this.$t("permissions.title")
          _icon = "vpn_key"
          _color = "info"
          break
        case "delete":
          _text = this.$t("global.delete")
          _icon = "fas fa-times"
          _color = "error"
          break
        case "remove":
          _text = this.$t("global.remove")
          _icon = "fas fa-minus"
          _color = "error"
          break
        case "show_filter":
          _text = this.$t("global.show_filter")
          _icon = "fas fa-filter"
          _color = "info"
          break
        case "filter":
          _text = this.$t("global.filter")
          _icon = "fas fa-filter"
          _color = "info"
          break
        case "pdf":
          _text = this.$t("global.pdf")
          _icon = "fas fa-pdf"
          _color = "info"
          break
        case "reset":
          _text = this.$t("global.reset")
          _icon = "fas fa-sync"
          _color = "info"
          break
        case "restore":
          _text = this.$t("global.restore")
          _icon = "fas fa-trash-restore"
          _color = "warning"
          break
        case "close":
          _text = this.$t("global.close")
          _icon = "fas fa-times"
          _color = "error"
          break
        case "cancel":
          _text = this.$t("global.cancel")
          _icon = "fas fa-ban"
          _color = "info"
          break
        case "clear":
          _text = this.$t("global.clear")
          _icon = "fas fa-minus-square"
          _color = "info"
          break
        case "merge":
          _text = this.$t("global.merge")
          _icon = "fas fa-object-group"
          _color = "info"
          break
        case "add_to_participant":
          _text = this.$t("enrolments.add_to_participant")
          _icon = "fas fa-check-square"
          _color = "info"
          break
        case "course_reg_form":
          _text = this.$t("courses.register_link")
          _icon = "fas fa-link"
          _color = "info"
          break
        case "upload":
          _text = this.$t("global.upload")
          _icon = "fas fa-paperclip"
          _color = "info"
          break
        case "crop":
          _text = this.$t("global.upload")
          _icon = "fas fa-crop-alt"
          _color = "info"
          break
        case "download":
          _text = this.$t("global.download")
          _icon = "fas fa-download"
          _color = "info"
          break
        case "check_in":
          _text = this.$t("checkin.check_in_btn")
          _icon = "fas fa-check-square"
          _color = "success"
          break
        case "did_not_meet":
          _text = this.$t("checkin.did_not_meet_btn")
          _icon = "fas fa-minus-square"
          _color = "warning"
          break
        case "run_report":
          _text = this.$t("reports.run_report")
          _icon = "fas fa-check-circle"
          _color = "success"
          break
        case "validate":
          _text = this.$t("global.validate")
          _icon = "fas fa-share-square"
          _color = "success"
          break
        case "export_excel":
          _text = this.$t("global.export_excel")
          _icon = "fas fa-file-excel"
          _color = "info"
          break
        case "switchcamera":
          _text = this.$t("global.switchcamera")
          _icon = "fas fa-camera"
          _color = "warning"
          break
        case "default":
          _text = ""
          _icon = ""
          _color = "info"
          break
      }

      this.btn_text = this.text ? this.text : _text
      this.btn_icon = this.icon ? this.icon : this.icon === null ? null : _icon
      this.btn_color = this.color ? this.color : _color
    }
  }
}
</script>
